export default __webpack_public_path__ + "static/media/screenShots_new-year-2.1661b4c8.jpg";